const Edit = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clip-path="url(#clip0_8947_7566)">
        <path
          d="M12.0003 6.66719L9.33368 4.00053M1.66699 14.3339L3.92324 14.0832C4.1989 14.0525 4.33673 14.0372 4.46556 13.9955C4.57985 13.9585 4.68862 13.9062 4.78892 13.8401C4.90196 13.7656 5.00002 13.6675 5.19614 13.4714L14.0003 4.66719C14.7367 3.93082 14.7367 2.73691 14.0003 2.00053C13.264 1.26415 12.0701 1.26415 11.3337 2.00053L2.52948 10.8047C2.33336 11.0008 2.2353 11.0989 2.16075 11.2119C2.09461 11.3122 2.04234 11.421 2.00533 11.5353C1.96363 11.6641 1.94831 11.802 1.91769 12.0776L1.66699 14.3339Z"
          stroke="white"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_8947_7566">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export default Edit;
